import React from "react";

const Results = ({ results }) => {
  
  const isActiveStatus = results && results[0]?.nsi00219?.vnsostk === "Действующий";

  const hasValidActivity =
    results.count > 0 &&
    results.items?.some(
      (item) => item.reActivityType?.name === "Деятельность в области автомобильного транспорта"
    ) 
    ;
   
  const licenseName = isActiveStatus
  ? results[0]?.vnaim || results[0]?.vfio
  : hasValidActivity
  ? results.items.find(
      (item) =>
        item.reActivityType?.name === "Деятельность в области автомобильного транспорта" 
    )?.licenseHolder?.name
  : null;
  
  
  
  const checkUNP = isActiveStatus
  ? results[0]?.ngrn
  : hasValidActivity
  ? results.items.find(
      (item) =>
        item.reActivityType?.name === "Деятельность в области автомобильного транспорта" 
    )?.licenseHolder?.unp
  : null;
    
  return (
    <div style={styles.container}>
      <h3>Результат проверки:</h3>
      {isActiveStatus && <p>Перевозчик <b>{licenseName}</b> с УНП <b>{checkUNP}</b> допущен к осуществлению международных автомобильных перевозок и сведения о перевозчике включены  в реестр перевозчиков, имеющих право выполнять международные автомобильные перевозки с использованием автомобилей, разрешенный максимальный вес которых, включая вес прицепа (полуприцепа), не превышает 3,5 тонны.</p>}
      {hasValidActivity && <p>Перевозчик <b>{licenseName}</b> с УНП <b>{checkUNP}</b> допущен к осуществлению международных автомобильных перевозок и сведения о перевозчике включены  в реестр перевозчиков, имеющих право выполнять международные автомобильные перевозки с использованием автомобилей, разрешенный максимальный вес которых, включая вес прицепа (полуприцепа), составляет 3,5 тонны и более.</p>}
      {!isActiveStatus && !hasValidActivity && <p>Отсутствуют сведения о включении в Реестр, проверьте правильность введенных данных.</p>}
    </div>
  );
};

const styles = {
  container: {
    marginTop: "20px",
    padding: "10px",
    maxWidth: "800px",     
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  message: {
    textAlign: "center",
    color: "#888",
  },
};

export default Results;